const UidispatcherApiModule = await import("uidispatcher_api/UidispatcherApiModule");
const NotificationStore: any = UidispatcherApiModule.NotificationStore;
export default NotificationStore;
export type Notification = {
	readonly type: "server-error" | "user-error" | "warning" | "info" | "success";
	readonly text: React.ReactNode;
	readonly timeout?: number;
	readonly dismissable?: boolean;
	readonly uuid?: string;
	readonly id: string; // the id is used for the selenium tag, and to deduplicate
};
